import logo from './logo.jpg'

export const theme = {
    color: {
      primary: "#e6007e",
      primaryHover: "#ae0052",
    },
    logoImage: logo,
    backend: "https://www.airproduct-airbook.ch/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "Airproduct",
      lineHeader: true,
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.airproduct.ch/cms/wm?catId=8833'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.airproduct.ch/cms/wm?catId=7202'
    },
  ],
  };